
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'ダッシュボードの作成',
	'dashboard': 'ダッシュボード',
	'dashboardTemplate': 'ダッシュボード・テンプレート',
	'createAV': '作成',
	'createAvEditNameLabel': '1. ビューに名前を付ける',
	'createAvSelectTemplateLabel': '2. テンプレートの選択',
	'tabLayoutLabel': 'タブ付きテンプレート',
	'infographicsLayoutLabel': 'インフォグラフィック・テンプレート',
	'singlePageLayoutLabel': '単一ページ・テンプレート',
	'customLayoutLabel': 'カスタム・テンプレート',
	'freeformTemplate': 'フリー・フォーム',
	'freeformTemplateDesc': '「フリー・フォーム」レイアウトでの視覚化は、画面サイズに関係なく、ユーザーがビュー内で指定したとおりのサイズおよび位置で表示されます。 他のレイアウトでは、視覚化のサイズと位置は、画面に合わせて調整されます。',
	'NoTemplate': 'フリー・フォーム',
	'Template1': '空白',
	'Template2': 'タイトル 1 by 2',
	'Template3': '2 over 1',
	'Template4': '4 over 1',
	'Template5': 'フッター 1 by 2',
	'Template6': '3 beside 1 over 1',
	'Template7': '4 beside 3 over 1',
	'Template8': '2 over 3 by 2',
	'Template9': '2 by 2',
	'Template10': '1 by 2 beside 2 by 2 over 1',
	'Template11': '3 by 1 over 1 by 2',
	'Template12': '2 over 1 beside 1 by 2',
	'Template13': 'One beside 1 by 2 beside 1 by 4',
	'Template14': 'ドロップ・ゾーン付きの空白',
	'Infographics1': '空白',
	'Infographics2': '4 行',
	'Infographics3': '4 行 (ヘッダー付き)',
	'Infographics4': '2 by 4',
	'Infographics5': '大きなトップ表示 (2 by 2)',
	'Infographics6': '2 by 4 (垂直ギャップ)',
	'Infographics7': '2 by 4 (互い違い)',
	'Infographics8': 'テニス・コート',
	'Infographics9': '3 by 4',
	'Infographics10': '4 by 8',
	'createAvDashboardLabel': 'レイアウト',
	'dashboard_template_save_success': 'ダッシュボード・テンプレートが保存されました。',
	'dashboard_template_prefix': 'テンプレート: \'%{name}\'',
	'dashboard_template_filters_removed': 'キャンバス上のフィルターが削除されました。',
	'createAvTabLabel': 'タブ付き',
	'createAvInfographicsLabel': '解説画像',
	'createAvSinglepageLabel': '単一ページ',
	'createAvCustomLabel': 'カスタム',
	'loadMoreLabel': 'さらにロード...',
	'backLabel': '戻る',
	'addSourceLabel': 'ソースの追加',
	'pinLabel': 'ピン',
	'errorLoadingDataSetMetaData': 'メタデータの読み取り中にエラーが発生しました',
	'errorLoadingDataSets': 'データ・セットのリストのロード中にエラーが発生しました',
	'errorLoadingDataSet': 'データ・セット \'%{datasetName}\' のメタデータがロードされませんでした。 詳細については管理者に問い合わせてください。',
	'okButton': 'OK',
	'createButton': '作成',
	'cancelButton': 'キャンセル',
	'copyButton': 'コピー',
	'selectTemplateLabel': 'テンプレートの選択',
	'noSourcesSelectedLabel': 'ソースが選択されていません',
	'find_label': '検索',
	'noDashboardFound': 'ダッシュボードを取得できません。 存在しないか、または表示するのに必要な権限がありません。',
	'errorLabel': 'エラー',
	'defaultName': '新規ダッシュボード',
	'noDashboardCapability': 'ダッシュボード・アプリケーションを実行する機能がありません',
	'noCapabilityForEdit': 'このダッシュボードを編集する機能がありません',
	'noCapabilityForSave': 'このダッシュボードを保存する機能がありません',
	'noCapabilityForPaste': 'コピーしたウィジェットをこのビューに貼り付ける機能がありません',
	'noCapabilityForPin': 'このピンを追加する機能がありません',
	'noDashboardPermission': 'このダッシュボードを表示するための十分な特権がありません',
	'sourceNotFound': '視覚化をロードできません。その関連ソース \'%{sourceName}\' が使用不可です。',
	'cmDuplicateName': 'この名前のアイテムが既に存在しています。 別の名前を試してください',
	'cmEmptySelection': 'ダッシュボードは削除されました。 新しいダッシュボードとして保存してみてください。',
	'propTheme': 'ビジュアル・テーマ',
	'defaultThemeLabel': 'デフォルト',
	'lightThemeLabel': '明るい',
	'darkThemeLabel': '暗い',
	'titleTextLabel': 'タイトル',
	'titleSmallTextLabel': 'タイトル (小)',
	'subtitleTextLabel': 'サブタイトル',
	'bodyTextLabel': '本文',
	'bodySmallTextLabel': '本体 (小)',
	'captionTextLabel': 'キャプション',
	'quoteTextLabel': '引用符',
	'quoteSmallTextLabel': '引用符 (小)',
	'responsiveTextLabel': '自動サイズ',
	'mediaWidgetLabel': 'メディア',
	'webpageWidgetLabel': 'Web ページ',
	'imageWidgetLabel': '画像',
	'textWidgetLabel': 'テキスト',
	'notebookWidgetLabel': 'ノートブック',
	'multipurposeWidgetLabel': '多目的',
	'textPlaceHolder': 'ここにテキストを入力してください',
	'titlePlaceHolder': 'ここにタイトルを入力してください',
	'toggleEditModeLabel': '編集に切り替え',
	'togglePreviewModeLabel': 'プレビューに切り替え',
	'editDashboardCoachMarkTitle': 'ダッシュボードの編集',
	'editDashboardCoachMarkContents': '鉛筆アイコンをクリックすると、このダッシュボードを編集できます。',
	'addDataCoachMarkTitle': 'データの追加',
	'addDataDashboardCoachMarkContents': 'データ・パネルのデータをダッシュボードにドラッグ・アンド・ドロップします。',
	'pageSelectWarning': 'タブを選択してください。',
	'screenshot_label': 'ダッシュボード %{title}',
	'screenshot_label_tab': 'ダッシュボード %{title} のタブ %{tabName}',
	'dataAssetPropertiesLabel': '視覚化のプロパティー',
	'modelFilter': 'フィルター',
	'invertSelectionToolTip': '反転フィルター選択項目',
	'clearFilterValueToolTip': 'フィルター値をクリア',
	'invertFilterSelection': '反転',
	'clearTextFilterValue': 'クリア',
	'filterConditionLabel': 'フィルター条件',
	'applyFilter': 'フィルターを適用',
	'itemCountText': '%{itemCount} 個のアイテムが選択されています',
	'itemExcludeCountText': '%{itemCount} 個のアイテムが除外されています',
	'moreMembers': 'さらに表示...',
	'searchHierarchyMembers': '検索を使用してメンバーを見つけます...',
	'propHideEmpty': '空を非表示にする',
	'propColorOrder': '色の順序',
	'propElementColor': '視覚化要素の色',
	'propLineColor': '線の色',
	'propLineAndSymbolColor': '線とシンボルの色',
	'propColumnColor': '縦棒の色',
	'propBarColor': 'バーの色',
	'propWordColor': 'ワードの色',
	'propAreaColor': '領域の色',
	'propRadialbarColor': '放射状棒グラフの色',
	'propColorPalettes': 'カラー・パレット',
	'propDashboardColorPalette': '現在のダッシュボード・パレット',
	'propNewDashboardPaletteLabel': 'カスタム・ダッシュボード・パレットの作成',
	'propDashboardChangePaletteLink': 'ダッシュボード・パレットの変更',
	'propHideLeafNode': 'リード・ラベルを非表示にする',
	'propOpacity': '不透明度',
	'propOpacityDescription': 'オブジェクトの不透明度を調整します。 0 から 100 までの値を入力してください',
	'addATab': '新規タブの追加',
	'propFredIsRed': '色の一貫性',
	'areaChartCaption': '領域',
	'areaChartDataSlot_categoriesLabel': '軸ラベル',
	'areaChartDataSlot_valuesLabel': '値',
	'areaChartProp_colorPaletteLabel': 'カラー・パレット',
	'areaChartProp_lineColorLabel': '領域の色',
	'areaChartProp_interpolationLabel': '曲線',
	'areaChartProp_interpolationDescription': 'データ点をつなぐ線は曲線です。',
	'areaChartProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'areaChartProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'areaChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'areaChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'areaChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'areaChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'areaChartProp_suppressZerosLabel': '空を非表示にする',
	'areaChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'barChartCaption': '棒グラフ',
	'barChartDataSlot_categoriesLabel': '軸ラベル',
	'barChartDataSlot_valuesLabel': '値',
	'barChartProp_colorPaletteLabel': 'カラー・パレット',
	'barChartProp_elementColorLabel': 'バーの色',
	'barChartProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'barChartProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'barChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'barChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'barChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'barChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'barChartProp_suppressZerosLabel': '空を非表示にする',
	'barChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'columnChartCaption': '縦棒グラフ',
	'columnChartDataSlot_categoriesLabel': '軸ラベル',
	'columnChartDataSlot_valuesLabel': '値',
	'columnChartProp_colorPaletteLabel': 'カラー・パレット',
	'columnChartProp_elementColorLabel': '縦棒の色',
	'columnChartProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'columnChartProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'columnChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'columnChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'columnChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'columnChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'columnChartProp_suppressZerosLabel': '空を非表示にする',
	'columnChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'bubbleChartCaption': 'バブル',
	'bubbleChartDataSlot_xAxisLabel': '水平軸',
	'bubbleChartDataSlot_yAxisLabel': '垂直軸',
	'bubbleChartDataSlot_sizeLabel': 'サイズ指定',
	'bubbleChartDataSlot_colorLabel': '色分け',
	'bubbleChartProp_colorPaletteLabel': 'カラー・パレット',
	'bubbleChartProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'bubbleChartProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'bubbleChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'bubbleChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'bubbleChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'bubbleChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'bubbleChartProp_hideLegendLabel': '凡例を非表示にする',
	'bubbleChartProp_hideLegendDescription': '凡例を非表示にします。',
	'bubbleChartProp_legendPositionLabel': '凡例の位置',
	'lineChartCaption': '折れ線グラフ',
	'lineChartDataSlot_categoriesLabel': '軸ラベル',
	'lineChartDataSlot_valuesLabel': '値',
	'lineChartProp_colorPaletteLabel': 'カラー・パレット',
	'lineChartProp_lineColorLabel': '線とシンボルの色',
	'lineChartProp_symbolShapeLabel': 'シンボルの形状',
	'lineChartProp_hideSymbolsLabel': 'シンボルを非表示にする',
	'lineChartProp_hideSymbolsDescription': 'シンボルを非表示にする',
	'lineChartProp_hideDataLinesLabel': '線を非表示にする',
	'lineChartProp_hideDataLinesDescription': '線を非表示にする',
	'lineChartProp_interpolationLabel': '曲線',
	'lineChartProp_interpolationDescription': 'データ点をつなぐ線は曲線です。',
	'lineChartProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'lineChartProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'lineChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'lineChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'lineChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'lineChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'lineChartProp_suppressZerosLabel': '空を非表示にする',
	'lineChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'packedBubbleChart1CatCaption': 'パックド・バブル',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'カテゴリー',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'サイズ指定',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'カラー・パレット',
	'packedBubbleChart1CatProp_elementColorLabel': 'バブルの色',
	'packedBubbleChart1CatProp_hideLabelLabel': 'ラベルを非表示にする',
	'packedBubbleChart1CatProp_hideValueLabel': '値を非表示にする',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': '軸スケールを維持',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'packedBubbleChart1CatProp_suppressZerosLabel': '空を非表示にする',
	'packedBubbleChart1CatProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'heatChartCaption': '熱',
	'heatChartDataSlot_valuesLabel': '熱の分類',
	'heatChartDataSlot_xAxisLabel': '水平軸',
	'heatChartDataSlot_yAxisLabel': '垂直軸',
	'heatChartProp_colorPaletteLabel': 'カラー・パレット',
	'heatChartProp_heatScalePaletteLabel': '色の順序',
	'heatChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'heatChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'heatChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'heatChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'heatChartProp_suppressZerosLabel': '空を非表示にする',
	'heatChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'heatChartProp_hideLegendLabel': '凡例を非表示にする',
	'heatChartProp_hideLegendDescription': '凡例を非表示にします。',
	'heatChartProp_legendPositionLabel': '凡例の位置',
	'pieChartCaption': '円グラフ',
	'pieChartDataSlot_categoriesLabel': 'カテゴリー',
	'pieChartDataSlot_valuesLabel': '値',
	'pieChartProp_colorPaletteLabel': 'カラー・パレット',
	'pieChartProp_hideRadialValueLabel': '値を非表示にする',
	'pieChartProp_pieAsDonutLabel': 'ドーナツ・グラフとして表示',
	'pieChartProp_pieAsDonutDescription': 'ドーナツ・グラフとして表示',
	'pieChartProp_suppressZerosLabel': '空を非表示にする',
	'pieChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'pieChartProp_hideLegendLabel': '凡例を非表示にする',
	'pieChartProp_hideLegendDescription': '凡例を非表示にします。',
	'pieChartProp_legendPositionLabel': '凡例の位置',
	'map1measureCaption': 'マップ',
	'map1measureDataSlot_categoriesLabel': '領域',
	'map1measureDataSlot_valuesLabel': '領域の熱',
	'map1measureProp_colorPaletteLabel': 'カラー・パレット',
	'map1measureProp_heatScalePaletteLabel': '色の順序',
	'map1measureProp_maintainAxisScalesLabel': '軸スケールを維持',
	'map1measureProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'map1measureProp_suppressZerosLabel': '空を非表示にする',
	'map1measureProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'map1measureProp_hideLegendLabel': '凡例を非表示にする',
	'map1measureProp_hideLegendDescription': '凡例を非表示にします。',
	'map1measureProp_legendPositionLabel': '凡例の位置',
	'radialChartCaption': '放射状グラフ',
	'radialChartDataSlot_categoriesLabel': 'カテゴリー',
	'radialChartDataSlot_valuesLabel': '値',
	'radialChartProp_colorPaletteLabel': 'カラー・パレット',
	'radialChartProp_elementColorLabel': '放射状棒グラフの色',
	'radialChartProp_hideRadialTitleLabel': 'タイトルを非表示にする',
	'radialChartProp_hideRadialValueLabel': '値を非表示にする',
	'radialChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'radialChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'radialChartProp_suppressZerosLabel': '空を非表示にする',
	'radialChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'pointChart1catCaption': '点グラフ',
	'pointChart1catDataSlot_valuesLabel': '値',
	'pointChart1catDataSlot_categoriesLabel': '軸ラベル',
	'pointChart1catProp_colorPaletteLabel': 'カラー・パレット',
	'pointChart1catProp_elementColorLabel': '形状の色',
	'pointChart1catProp_symbolShapeLabel': 'シンボルの形状',
	'pointChart1catProp_symbolFillLabel': '形状の塗りつぶし',
	'pointChart1catProp_symbolFillDescription': 'シンボルを塗りつぶす色を表示します。',
	'pointChart1catProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'pointChart1catProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'pointChart1catProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'pointChart1catProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'pointChart1catProp_maintainAxisScalesLabel': '軸スケールを維持',
	'pointChart1catProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'pointChart1catProp_suppressZerosLabel': '空を非表示にする',
	'pointChart1catProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'scatterPlotChartNoCatCaption': '分布図',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': '水平軸',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': '垂直軸',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'カラー・パレット',
	'scatterPlotChartNoCatProp_elementColorLabel': '要素の色',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'シンボルの形状',
	'scatterPlotChartNoCatProp_symbolFillLabel': '形状の塗りつぶし',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'シンボルを塗りつぶす色を表示します。',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'radialBarChartCaption': '放射状棒グラフ',
	'radialBarChartDataSlot_categoriesLabel': 'カテゴリー',
	'radialBarChartDataSlot_valuesLabel': '値',
	'radialBarChartProp_colorPaletteLabel': 'カラー・パレット',
	'radialBarChartProp_elementColorLabel': '放射状棒グラフの色',
	'radialBarChartProp_hideRadialTitleLabel': 'タイトルを非表示にする',
	'radialBarChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'radialBarChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'radialBarChartProp_suppressZerosLabel': '空を非表示にする',
	'radialBarChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'lineColumnComboChartCaption': '折れ線と縦棒',
	'lineColumnComboChartDataSlot_categoryLabel': '軸ラベル',
	'lineColumnComboChartDataSlot_lineValueLabel': '線の値',
	'lineColumnComboChartDataSlot_columnValueLabel': '縦棒の値',
	'lineColumnComboChartProp_colorPaletteLabel': 'カラー・パレット',
	'lineColumnComboChartProp_elementColorLabel': '縦棒の色',
	'lineColumnComboChartProp_lineColorLabel': '線とシンボルの色',
	'lineColumnComboChartProp_symbolShapeLabel': 'シンボルの形状',
	'lineColumnComboChartProp_hideSymbolsLabel': 'シンボルを非表示にする',
	'lineColumnComboChartProp_hideSymbolsDescription': 'シンボルを非表示にする',
	'lineColumnComboChartProp_hideDataLinesLabel': '線を非表示にする',
	'lineColumnComboChartProp_hideDataLinesDescription': '線を非表示にする',
	'lineColumnComboChartProp_interpolationLabel': '曲線',
	'lineColumnComboChartProp_interpolationDescription': 'データ点をつなぐ線は曲線です。',
	'lineColumnComboChartProp_hideGridLinesLabel': 'グリッド線を非表示にする',
	'lineColumnComboChartProp_hideGridLinesDescription': 'グリッド線を非表示にする',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': '軸タイトルのラベルを非表示にする',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': '軸のタイトルを非表示にします。',
	'lineColumnComboChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'lineColumnComboChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'lineColumnComboChartProp_suppressZerosLabel': '空を非表示にする',
	'lineColumnComboChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'lineColumnComboChartProp_hideLegendLabel': '凡例を非表示にする',
	'lineColumnComboChartProp_hideLegendDescription': '凡例を非表示にします。',
	'lineColumnComboChartProp_legendPositionLabel': '凡例の位置',
	'summaryCaption': '要約',
	'areaName': '領域',
	'areaDescription': '領域',
	'areaDataSlot_colorLabel': '色分け',
	'areaDataSlot_valuesLabel': '値',
	'areaDataSlot_categoriesLabel': '軸ラベル',
	'bubbleName': 'バブル',
	'bubbleDescription': 'バブル',
	'bubbleDataSlot_yAxisLabel': '垂直軸',
	'bubbleDataSlot_xAxisLabel': '水平軸',
	'bubbleDataSlot_sizeLabel': 'サイズ指定',
	'bubbleDataSlot_colorLabel': '色分け',
	'clusterBarName': '棒グラフ',
	'clusterBarDescription': '棒グラフ',
	'clusterBarDataSlot_colorLabel': '色分け',
	'clusterBarDataSlot_valuesLabel': '値',
	'clusterBarDataSlot_categoriesLabel': '軸ラベル',
	'clusterBarDataSlot_valuesRepeatingLabel': '値',
	'clusterColumnName': '縦棒グラフ',
	'clusterColumnDescription': '縦棒グラフ',
	'clusterColumnDataSlot_colorLabel': '色分け',
	'clusterColumnDataSlot_valuesLabel': '値',
	'clusterColumnDataSlot_categoriesLabel': '軸ラベル',
	'clusterColumnDataSlot_valuesRepeatingLabel': '値',
	'clusterLineName': '折れ線グラフ',
	'clusterLineDescription': '折れ線グラフ',
	'clusterLineDataSlot_colorLabel': '色分け',
	'clusterLineDataSlot_valuesLabel': '垂直軸',
	'clusterLineDataSlot_categoriesLabel': '水平軸',
	'clusterLineDataSlot_valuesRepeatingLabel': '値',
	'gridName': 'グリッド',
	'gridDescription': 'グリッド',
	'gridDataSlot_grid_colsLabel': '縦棒グラフ',
	'heatName': '熱',
	'heatDescription': '熱',
	'heatDataSlot_yAxisLabel': '垂直軸',
	'heatDataSlot_xAxisLabel': '水平軸',
	'heatDataSlot_valuesLabel': '熱の分類',
	'lineColumnComboName': '折れ線と縦棒',
	'lineColumnComboDescription': '折れ線と縦棒',
	'lineColumnComboDataSlot_lineValueLabel': '線の値',
	'lineColumnComboDataSlot_categoryLabel': '軸ラベル',
	'lineColumnComboDataSlot_columnValueLabel': '縦棒の値',
	'mapName': '既存の地図',
	'mapDescription': '既存の地図',
	'mapDataSlot_sizeLabel': '点のサイズ',
	'mapDataSlot_valuesLabel': '領域の熱',
	'mapDataSlot_sizeHeatLabel': '点の熱',
	'mapDataSlot_categoriesLabel': '領域',
	'packedBubbleName': 'パックド・バブル',
	'packedBubbleDescription': 'パックド・バブル',
	'packedBubbleDataSlot_sizeLabel': 'サイズ指定',
	'packedBubbleDataSlot_colorLabel': '色分け',
	'packedBubbleDataSlot_categoriesLabel': 'カテゴリー',
	'pieName': '円グラフ',
	'pieDescription': '円グラフ',
	'pieDataSlot_valuesLabel': '値',
	'pieDataSlot_categoriesLabel': 'カテゴリー',
	'playerName': 'データ・プレイヤー',
	'playerDescription': 'データ・プレイヤー',
	'playerDataSlot_categoriesLabel': '軸ラベル',
	'pointName': '点グラフ',
	'pointDescription': '点グラフ',
	'pointDataSlot_colorLabel': '色分け',
	'pointDataSlot_valuesLabel': '値',
	'pointDataSlot_categoriesLabel': '軸ラベル',
	'radialName': '放射状グラフ',
	'radialDescription': '放射状グラフ',
	'radialDataSlot_valuesLabel': '値',
	'radialDataSlot_maxSizeLabel': '最大値',
	'radialDataSlot_categoriesLabel': 'カテゴリー',
	'radialBarName': '放射状棒グラフ',
	'radialBarDescription': '放射状棒グラフ',
	'radialBarDataSlot_valuesLabel': '値',
	'radialBarDataSlot_categoriesLabel': 'カテゴリー',
	'scatterPlotName': '分布図',
	'scatterPlotDescription': '分布図',
	'scatterPlotDataSlot_yAxisLabel': '垂直軸',
	'scatterPlotDataSlot_xAxisLabel': '水平軸',
	'scatterPlotDataSlot_colorLabel': '色分け',
	'scatterPlotDataSlot_categoriesLabel': '点',
	'stackedBarName': '積み上げ棒グラフ',
	'stackedBarDescription': '積み上げ棒グラフ',
	'stackedBarDataSlot_colorLabel': '色分け',
	'stackedBarDataSlot_valuesLabel': '値',
	'stackedBarDataSlot_categoriesLabel': '軸ラベル',
	'stackedBarDataSlot_valuesRepeatingLabel': '値',
	'stackedColumnName': '積み上げ縦棒グラフ',
	'stackedColumnDescription': '積み上げ縦棒グラフ',
	'stackedColumnDataSlot_colorLabel': '色分け',
	'stackedColumnDataSlot_valuesLabel': '値',
	'stackedColumnDataSlot_categoriesLabel': '軸ラベル',
	'stackedColumnDataSlot_valuesRepeatingLabel': '値',
	'summaryChartName': '要約',
	'summaryChartDescription': '要約',
	'summaryChartDataSlot_valuesLabel': '値',
	'treeMapName': 'ツリー・マップ',
	'treeMapDescription': 'ツリー・マップ',
	'treeMapDataSlot_colorLabel': '熱の分類',
	'treeMapDataSlot_valuesLabel': 'サイズ指定',
	'treeMapDataSlot_categoriesLabel': 'レベル 1',
	'treeMapDataSlot_level3Label': 'レベル 3',
	'treeMapDataSlot_level2Label': 'レベル 2',
	'wordCloudName': 'ワード・クラウド',
	'wordCloudDescription': 'ワード・クラウド',
	'wordCloudDataSlot_colorLabel': '色分け',
	'wordCloudDataSlot_scaleLabel': 'サイズ指定',
	'wordCloudDataSlot_wordLabel': 'ワード',
	'treeMap1Cat1MeasureChartCaption': 'ツリー・マップ',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'レベル 1',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'サイズ指定',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'カラー・パレット',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'カラー・パレット',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'カラー・パレット',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'カラー・パレット',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'カラー・パレット',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'カラー・パレット',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': '軸スケールを維持',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': '空を非表示にする',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': '凡例を非表示にする',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': '凡例を非表示にします。',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': '凡例の位置',
	'wordChart1Cat1MeasureCaption': 'ワード・クラウド',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'ワード',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'サイズ指定',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'カラー・パレット',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'ワードの色',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': '軸スケールを維持',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': '軸上の最小値と最大値を常に表示します。',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': '空を非表示にする',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': '関連する値のないカテゴリーを非表示にします。',
	'missingDataSetData': 'このデータ・セットのデータは使用できません。 このデータ・セットを更新するか、または管理者に連絡して、ソースにアクセスできるようにしてください。',
	'hideShowSummaries': '要約表示の非表示',
	'crosstabName': 'クロス集計',
	'value_is_not_available': '適用外',
	'swapRowsAndColumns': '行と列の交換',
	'NoPinsCollected': 'ピン留めした視覚化はありません',
	'pinSearchOld': 'マイピンの検索',
	'pinDeletedToast': 'ピンは除去されました',
	'pinAddedToast': 'ピンがマイピンに正常に追加されました',
	'pinRetrieveError': '1 つ以上のピンを取得できません。 後で再試行してください。',
	'pinErrorTitle': 'ピン留めエラー',
	'pinRemove': 'ピンの削除',
	'deletePin': 'ピンの削除',
	'dataset_time': '時刻',
	'dataset_date': '日付',
	'dataset_location': '場所',
	'dataset_number': '数',
	'dataset_text': 'テキスト',
	'widgetConditionalFormatLabel': '条件付き書式制御の切り替え',
	'deletePinConfirmationMessage': 'このピンを削除しますか? この処理を元に戻すことはできません。',
	'deletePinConfirm': '削除の確認',
	'pinDeleteError': '1 つ以上のピンを削除できません。 後で再試行してください。',
	'conditionalPalettePickerLabel': '%{title} 値の分布',
	'HistogramYAxisTitle': '個数',
	'metadataPickerTitle': 'データ・セットの作成',
	'moreTitle': 'その他',
	'remove_slider_handle': 'ハンドルの削除',
	'missingFiltering': '欠落している列:',
	'unSupportedPromptType': 'プロンプト・シナリオは現在、サポートされていません。',
	'preAggregateLabel': 'データ・ソースからプロンプト値を適用',
	'postAggregateLabel': 'レポートのプロンプト値を適用',
	'preAggregateText': '範囲はデータ・ソース内の値を使用します。ダッシュボードに表示されている値ではありません。',
	'tabName_general': '全般',
	'tabName_visDetails': '詳細',
	'tabName_textDetails': 'テキストの詳細',
	'tabName_mediaDetails': 'メディアの詳細',
	'tabName_webDetails': 'Web ページの詳細',
	'tabName_imageDetails': '画像の詳細',
	'tabName_visualization': '視覚化',
	'sectionName_canvas': 'キャンバス',
	'sectionName_colorsAndThemes': '色とテーマ',
	'sectionName_appearance': '外観',
	'sectionName_advanced': '詳細設定',
	'sectionName_layout': 'レイアウト',
	'sectionName_tabs': 'タブ',
	'sectionName_tabTitle': 'ラベル',
	'sectionName_tabBackground': '背景',
	'addDataSourceDialogTitle': 'データ・ソースを追加',
	'addDataSourceDialogButtonLabel': '追加',
	'shapesDoubleChevron': 'ダブル・シェブロン',
	'widgetsPanelTitle': 'ウィジェット',
	'widgetsPanelImageLibraryTab': 'イメージ・ライブラリー',
	'widgetsPanelSectionBasic': '標準',
	'widgetsPanelSectionAdvanced': '詳細設定',
	'widgetsPanelSectionShapes': '形状',
	'customWidgetsTitle': 'カスタム・ウィジェット',
	'filterItemCanvasMove': 'キャンバスに追加',
	'filterOverflowMenu_Global': '「すべてのタブ」オーバーフロー・メニュー',
	'filterOverflowMenu_Tab': '「このタブ」オーバーフロー・メニュー',
	'filterOverflowMenu_Item': '「フィルター」オーバーフロー・メニュー',
	'filterOverflowMenu_Single': 'オーバーフロー・メニュー',
	'filterItemEdit': 'フィルター値の編集',
	'filterDeleteAllItems': 'フィルターをすべて削除',
	'filterClearAllItems': 'フィルターをすべてクリア',
	'filterClearSelection': 'フィルターのクリア',
	'filterPlayerMode': 'プレイヤーの表示',
	'filterStaticMode': 'リストの表示',
	'filterInvertSelection': 'フィルターの反転',
	'filterIconLabel_Global': 'すべてのタブ',
	'filterIconLabel_Single': 'フィルター',
	'filterIconLabel_Tab': 'このタブ',
	'filterIconTooltip_Global': 'すべてのタブ',
	'filterIconTooltip_Tab': 'このタブ',
	'filterIconTooltip_Single': 'フィルター',
	'filterItemDelete': 'フィルターの削除',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': '次を除くすべて: %{from}-%{to}',
	'filterExcept': '%{values} 以外',
	'filterAll': 'すべて',
	'filterBlank': '(ブランク)',
	'filterDisableRangeInvert': 'この列が\'すべてのタブ\'でフィルターされている場合は使用できません。',
	'filterDisableHierarchyInvert': 'この列が階層フィルターの場合は使用できません。',
	'filterSelectedOfTotal': '%{totalMembers} 個中 %{selected} 個',
	'filter_date_before': '%{to} より前',
	'filter_date_before_except': '%{to} より前ではない',
	'filter_date_after': '%{from} の後',
	'filter_date_after_except': '%{from} の後ではない',
	'filter_date_between': '%{from} から %{to} の間',
	'filter_date_between_except': '%{from} から %{to} の間ではない',
	'filter_drag_and_drop_all_tabs': 'すべてのタブをフィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filter_drag_and_drop_current_tab': 'このタブをフィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'filter_drag_and_drop_single_dock': 'フィルターにかけるには、データをここにドラッグ・アンド・ドロップします。',
	'errMsgFilterItemGenericTitle': 'フィルター値をロードできません',
	'widgetChromeRotate': '回転',
	'toolbarRegionLabel': 'ツールバー',
	'toolbarActionDelete': '削除',
	'toolbarActionGroup': 'グループ',
	'toolbarActionUngroup': 'グループ化解除',
	'toolbarActionOrderToFront': '前面へ移動',
	'toolbarActionOrderToBack': '背面へ移動',
	'toolbarActionEditTitle': 'タイトルの編集',
	'toolbarActionWrapTitle': 'タイトルの折り返し',
	'toolbarActionPin': '収集',
	'toolbarActionPinOld': 'ピン',
	'toolbarActionAlign': '位置を揃える',
	'alignWidgetLeft': '左',
	'alignWidgetCenter': '中央',
	'alignWidgetRight': '右',
	'alignWidgetTop': '一番上へ',
	'alignWidgetMiddle': '中央',
	'alignWidgetBottom': '下から',
	'toolbarChangeVisualization': '視覚化の変更',
	'live_label': 'グラフ',
	'filter_label': 'フィルター',
	'one_named_live': '%{name} グラフ',
	'one_named_live_numbered': '%{name} グラフ (%{number})',
	'one_unknown_live': 'グラフ',
	'one_unknown_live_numbered': 'グラフ (%{number})',
	'few_live': '%{count} 個のグラフのグループ',
	'many_live': '%{count} 個のグラフのグループ',
	'one_custom': 'カスタム・ウィジェット',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} フィルター',
	'one_named_filter_numbered': '%{name} フィルター (%{number})',
	'one_unknown_filter': 'フィルター',
	'one_unknown_filter_numbered': 'フィルター (%{number})',
	'few_filter': '%{count} 個のフィルターのグループ',
	'many_filter': '%{count} 個のフィルターのグループ',
	'LIVE_bar_has_mapping': '%{values} 棒グラフ',
	'LIVE_bar_has_mapping_numbered': '%{values} 棒グラフ (%{number})',
	'LIVE_bar_opt_mapping': '%{values} 別の %{categories} の棒グラフ',
	'LIVE_bar_opt_mapping_numbered': '%{values} 別の %{categories} の棒グラフ (%{number})',
	'LIVE_bar_no_mapping': '空の棒グラフ',
	'LIVE_bar_no_mapping_numbered': '空の棒グラフ (%{number})',
	'LIVE_bar_named': '%{name} 棒グラフ',
	'LIVE_bar_named_numbered': '%{name} 棒グラフ (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} 積み上げ横棒グラフ',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} 積み上げ横棒グラフ (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{values} 別の %{categories} の積み上げ横棒グラフ',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{values} 別の %{categories} の積み上げ横棒グラフ (%{number})',
	'LIVE_stacked_bar_no_mapping': '空の積み上げ横棒グラフ',
	'LIVE_stacked_bar_no_mapping_numbered': '空の積み上げ横棒グラフ (%{number})',
	'LIVE_stacked_bar_named': '%{name} 積み上げ横棒グラフ',
	'LIVE_stacked_bar_named_numbered': '%{name} 積み上げ横棒グラフ (%{number})',
	'LIVE_bubble_has_mapping': '%{x} および %{y} 別の %{categories} のバブル・チャート',
	'LIVE_bubble_has_mapping_numbered': '%{x} および %{y} 別の %{categories} のバブル・チャート (%{number})',
	'LIVE_bubble_no_mapping': '空のバブル・チャート',
	'LIVE_bubble_no_mapping_numbered': '空のバブル・チャート (%{number})',
	'LIVE_bubble_named': '%{name} バブル・チャート',
	'LIVE_bubble_named_numbered': '%{name} バブル・チャート (%{number})',
	'LIVE_composite_has_mapping': '%{columnValue} および %{lineValue} 別の %{categories} の複合グラフ',
	'LIVE_composite_has_mapping_numbered': '%{columnValue} および %{lineValue} 別の %{categories} の複合グラフ (%{number})',
	'LIVE_composite_no_mapping': '空の複合グラフ',
	'LIVE_composite_no_mapping_numbered': '空の複合グラフ (%{number})',
	'LIVE_composite_named': '%{name} 複合グラフ',
	'LIVE_composite_named_numbered': '%{name} 複合グラフ (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} デシジョン・ツリー',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} デシジョン・ツリー (%{number})',
	'LIVE_decision_tree_no_mapping': '空のデシジョン・ツリー',
	'LIVE_decision_tree_no_mapping_numbered': '空のデシジョン・ツリー (%{number})',
	'LIVE_decision_tree_named': '%{name} デシジョン・ツリー',
	'LIVE_decision_tree_named_numbered': '%{name} デシジョン・ツリー (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} パックド・バブル・チャート',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} パックド・バブル・チャート (%{number})',
	'LIVE_packed_bubble_no_mapping': '空のパックド・バブル・チャート',
	'LIVE_packed_bubble_no_mapping_numbered': '空のパックド・バブル・チャート (%{number})',
	'LIVE_packed_bubble_named': '%{name} パックド・バブル・チャート',
	'LIVE_packed_bubble_named_numbered': '%{name} パックド・バブル・チャート (%{number})',
	'LIVE_pie_has_mapping': '%{values} 別の %{categories} の円グラフ',
	'LIVE_pie_has_mapping_numbered': '%{values} 別の %{categories} の円グラフ (%{number})',
	'LIVE_pie_no_mapping': '空の円グラフ',
	'LIVE_pie_no_mapping_numbered': '空の円グラフ (%{number})',
	'LIVE_pie_named': '%{name} 円グラフ',
	'LIVE_pie_named_numbered': '%{name} 円グラフ (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{values} 別の %{categories} のドーナツ・グラフ',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{values} 別の %{categories} のドーナツ・グラフ (%{number})',
	'LIVE_pie_as_donut_no_mapping': '空のドーナツ・グラフ',
	'LIVE_pie_as_donut_no_mapping_numbered': '空のドーナツ・グラフ (%{number})',
	'LIVE_pie_as_donut_named': '%{name} ドーナツ・グラフ',
	'LIVE_pie_as_donut_named_numbered': '%{name} ドーナツ・グラフ (%{number})',
	'LIVE_line_has_mapping': '%{values} 別の %{categories} の折れ線グラフ',
	'LIVE_line_has_mapping_numbered': '%{values} 別の %{categories} の折れ線グラフ (%{number})',
	'LIVE_line_no_mapping': '空の折れ線グラフ',
	'LIVE_line_no_mapping_numbered': '空の折れ線グラフ (%{number})',
	'LIVE_line_named': '%{name} 折れ線グラフ',
	'LIVE_line_named_numbered': '%{name} 折れ線グラフ (%{number})',
	'LIVE_area_has_mapping': '%{values} 別の %{categories} の面グラフ',
	'LIVE_area_has_mapping_numbered': '%{values} 別の %{categories} の面グラフ (%{number})',
	'LIVE_area_no_mapping': '空の面グラフ',
	'LIVE_area_no_mapping_numbered': '空の面グラフ (%{number})',
	'LIVE_area_named': '%{name} 面グラフ',
	'LIVE_area_named_numbered': '%{name} 面グラフ (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{values} 別の %{categories} の積み上げパーセント面グラフ',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{values} 別の %{categories} の積み上げパーセント面グラフ (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': '空の積み上げパーセント面グラフ',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': '空の積み上げパーセント面グラフ (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} 積み上げパーセント面グラフ',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} 積み上げパーセント面グラフ (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} ヒート・マップ',
	'LIVE_heatmap_has_mapping_numbered': '%{color} ヒート・マップ (%{number})',
	'LIVE_heatmap_no_mapping': '空のヒート・マップ',
	'LIVE_heatmap_no_mapping_numbered': '空のヒート・マップ (%{number})',
	'LIVE_heatmap_named': '%{name} ヒート・マップ',
	'LIVE_heatmap_named_numbered': '%{name} ヒート・マップ (%{number})',
	'LIVE_network_opt_mapping': '%{series} および %{values} 別の %{categories} のネットワーク',
	'LIVE_network_opt_mapping_numbered': '%{series} および %{values} 別 %{categories} のネットワーク (%{number})',
	'LIVE_network_has_mapping': '%{series} 別 %{categories} のネットワーク',
	'LIVE_network_has_mapping_numbered': '%{series} 別 %{categories} のネットワーク (%{number})',
	'LIVE_network_no_mapping': '空のネットワーク',
	'LIVE_network_no_mapping_numbered': '空のネットワーク (%{number})',
	'LIVE_network_named': '%{name} ネットワーク',
	'LIVE_network_named_numbered': '%{name} ネットワーク (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{values} 別の %{categories} の放射状棒グラフ',
	'LIVE_radial_bar_opt_mapping_numbered': '%{values} 別の %{categories} の放射状棒グラフ (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} 放射状棒グラフ',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} 放射状棒グラフ (%{number})',
	'LIVE_radial_bar_no_mapping': '空の放射状棒グラフ',
	'LIVE_radial_bar_no_mapping_numbered': '空の放射状棒グラフ (%{number})',
	'LIVE_radial_bar_named': '%{name} 放射状棒グラフ',
	'LIVE_radial_bar_named_numbered': '%{name} 放射状棒グラフ (%{number})',
	'LIVE_spiral_has_mapping': '%{values} スパイラル図',
	'LIVE_spiral_has_mapping_numbered': '%{values} スパイラル図 (%{number})',
	'LIVE_spiral_no_mapping': '空のスパイラル図',
	'LIVE_spiral_no_mapping_numbered': '空のスパイラル図 (%{number})',
	'LIVE_spiral_named': '%{name} スパイラル図',
	'LIVE_spiral_named_numbered': '%{name} スパイラル図 (%{number})',
	'LIVE_treemap_has_mapping': '%{size} 別の %{categories} のツリー・マップ',
	'LIVE_treemap_has_mapping_numbered': '%{size} 別の %{categories} のツリー・マップ (%{number})',
	'LIVE_treemap_no_mapping': '空のツリー・マップ',
	'LIVE_treemap_no_mapping_numbered': '空のツリー・マップ (%{number})',
	'LIVE_treemap_named': '%{name} ツリー・マップ',
	'LIVE_treemap_named_numbered': '%{name} ツリー・マップ (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} ワード・クラウド',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} ワード・クラウド (%{number})',
	'LIVE_wordcloud_no_mapping': '空のワード・クラウド',
	'LIVE_wordcloud_no_mapping_numbered': '空のワード・クラウド (%{number})',
	'LIVE_wordcloud_named': '%{name} ワード・クラウド',
	'LIVE_wordcloud_named_numbered': '%{name} ワード・クラウド (%{number})',
	'LIVE_data_player_has_mapping': '%{category} データ・プレイヤー',
	'LIVE_data_player_has_mapping_numbered': '%{category} データ・プレイヤー (%{number})',
	'LIVE_data_player_no_mapping': '空のデータ・プレイヤー',
	'LIVE_data_player_no_mapping_numbered': '空のデータ・プレイヤー (%{number})',
	'LIVE_data_player_named': '%{name} データ・プレイヤー',
	'LIVE_data_player_named_numbered': '%{name} データ・プレイヤー (%{number})',
	'LIVE_map_has_mapping': '%{locations} マップ',
	'LIVE_map_has_mapping_numbered': '%{locations} マップ (%{number})',
	'LIVE_map_no_mapping': '空のマップ',
	'LIVE_map_no_mapping_numbered': '空のマップ (%{number})',
	'LIVE_map_named': '%{name} マップ',
	'LIVE_map_named_numbered': '%{name} マップ (%{number})',
	'LIVE_point_has_mapping': '%{values} 別の %{categories} の点グラフ',
	'LIVE_point_has_mapping_numbered': '%{values} 別の %{categories} の点グラフ (%{number})',
	'LIVE_point_no_mapping': '空の点グラフ',
	'LIVE_point_no_mapping_numbered': '空の点グラフ (%{number})',
	'LIVE_point_named': '%{name} 点グラフ',
	'LIVE_point_named_numbered': '%{name} 点グラフ (%{number})',
	'LIVE_column_has_mapping': '%{values} 縦棒グラフ',
	'LIVE_column_has_mapping_numbered': '%{values} 縦棒グラフ (%{number})',
	'LIVE_column_opt_mapping': '%{values} 別の %{categories} の縦棒グラフ',
	'LIVE_column_opt_mapping_numbered': '%{values} 別の %{categories} の縦棒グラフ (%{number})',
	'LIVE_column_no_mapping': '空の縦棒グラフ',
	'LIVE_column_no_mapping_numbered': '空の縦棒グラフ (%{number})',
	'LIVE_column_named': '%{name} 縦棒グラフ',
	'LIVE_column_named_numbered': '%{name} 縦棒グラフ (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} 積み上げ縦棒グラフ',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} 積み上げ縦棒グラフ (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{values} 別の %{categories} の積み上げ縦棒グラフ',
	'LIVE_stacked_column_opt_mapping_numbered': '%{values} 別の %{categories} の積み上げ縦棒グラフ (%{number})',
	'LIVE_stacked_column_no_mapping': '空の積み上げ縦棒グラフ',
	'LIVE_stacked_column_no_mapping_numbered': '空の積み上げ縦棒グラフ (%{number})',
	'LIVE_stacked_column_named': '%{name} 積み上げ縦棒グラフ',
	'LIVE_stacked_column_named_numbered': '%{name} 積み上げ縦棒グラフ (%{number})',
	'LIVE_scatter_opt_mapping': '%{x} および %{y} 別の %{categories} の分布図',
	'LIVE_scatter_opt_mapping_numbered': '%{x} および %{y} 別の %{categories} の分布図 (%{number})',
	'LIVE_scatter_has_mapping': '%{x} と %{y} の分布図',
	'LIVE_scatter_has_mapping_numbered': '%{x} と %{y} の分布図 (%{number})',
	'LIVE_scatter_no_mapping': '空の分布図',
	'LIVE_scatter_no_mapping_numbered': '空の分布図 (%{number})',
	'LIVE_scatter_named': '%{name} の分布図',
	'LIVE_scatter_named_numbered': '%{name} の分布図 (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} 累加縦棒グラフ',
	'LIVE_waterfall_has_mapping_numbered': '%{values} 累加縦棒グラフ (%{number})',
	'LIVE_waterfall_no_mapping': '空の累加縦棒グラフ',
	'LIVE_waterfall_no_mapping_numbered': '空の累加縦棒グラフ (%{number})',
	'LIVE_waterfall_named': '%{name} 累加縦棒グラフ',
	'LIVE_waterfall_named_numbered': '%{name} 累加縦棒グラフ (%{number})',
	'LIVE_empty_visualization_hint_title': '視覚化の作成',
	'LIVE_empty_visualization_hint_description': 'この位置か左のスロットに列をドラッグ・アンド・ドロップします。',
	'LIVE_slots_required_field_description': '%{asterisk} は必須フィールドを示します',
	'LIVE_slots_drag_and_drop_description': '上のスロットにデータをドラッグ・アンド・ドロップして、視覚化を作成してフィルターに掛けます。',
	'requiredField': '必須フィールド',
	'fullScreenEnter': 'フルスクリーンの開始',
	'fullScreenClose': 'フルスクリーンの終了',
	'noExtraText_multipurpose': '多目的プレースホルダー',
	'noExtraText_multipurpose_numbered': '多目的プレースホルダー (%{number})',
	'one_placeholder_vis': '視覚化プレースホルダー',
	'one_placeholder_vis_numbered': '視覚化プレースホルダー (%{number})',
	'one_placeholder_text': 'テキスト・プレースホルダー',
	'one_placeholder_text_numbered': 'テキスト・プレースホルダー (%{number})',
	'few_placeholder_text': '%{count} テキスト・プレースホルダーのグループ',
	'many_placeholder_text': '%{count} テキスト・プレースホルダーのグループ',
	'filter_includesAll': 'すべて含める',
	'timeline_filter_moved_to': 'タイム・ライン・フィルター %{id} を %{time} に移動',
	'timelineSettingsButton': '再生オプション',
	'autoPlay': 'すべてのシーンを再生',
	'loop': 'ループ',
	'noSceneTransitionLabel': 'なし',
	'sceneTransitionPropertyLabel': 'シーンの遷移',
	'animatedPathSceneTransitionLabel': 'アニメーションのパス',
	'sweepSceneTransitionLabel': 'スイープ',
	'propAniAnimation': 'アニメーション',
	'propAniTypeEntrance': '開始アニメーション',
	'propAniDirectionIn': '開始方向',
	'propAniTypeExit': '終了アニメーション',
	'propAniDirectionOut': '終了方向',
	'propAniDirection': '方向',
	'timelineAnimationProperties': 'アニメーション・プロパティーを開く',
	'editStoryCoachMarkTitle': 'ストーリーの編集',
	'editStoryCoachMarkContents': 'このストーリーを編集するには、鉛筆アイコンをクリックします。',
	'addDataStoryCoachMarkContents': 'データ・パネルのデータをストーリーにドラッグ・アンド・ドロップします。',
	'expandSceneCoachmarkTitle': 'タイムラインを開く',
	'expandSceneCoachmarkContents': '時刻と期間に基づいてオブジェクト可視性を調整することにより、シーンをアニメーションにします。',
	'overviewCoachmarkTitle': 'シーンの概要',
	'overviewCoachmarkContents': 'ストーリーの開始時と終了時にシーンの概要を使用して、すべてのシーンの全体像を示すことができます。 シーンの概要から、シーンをクリックしてドラッグして別のシーンと入れ替えることができます。 シーンの概要は、ストーリーのプロパティーで表示または非表示にできます。',
	'animatedPathCoachmarkTitle': 'アニメーションのパス',
	'animatedPathCoachmarkContents': 'あるシーンから別のシーンまでオブジェクトをアニメーション表示するには、そのオブジェクトを含むシーンを複製します。 次に、複製したオブジェクトを新しいシーンで移動、サイズ変更、または回転させます。',
	'tabName_animation': 'アニメーション',
	'textWidgetIconPlaceholderText': 'クリックしてテキストを追加します',
	'visIconPlaceholderText': 'データをドラッグ・アンド・ドロップして視覚化を作成します',
	'launchNewExplore': '新規閲覧ビュー',
	'addTo': '追加先',
	'addToExisting': '既存のものに追加...',
	'exploreData': '閲覧',
	'explore_remove_widget_styles': '色設定などの視覚化のカスタム・プロパティーは閲覧ビューに保持されません。',
	'editNotebook': 'ウィジェットの編集',
	'thumbnails_error_fetching': 'サムネイルの取り出し中にエラーが生じました',
	'copy': '%{count} 個の資産がコピーされました',
	'specConvertErr': 'ダッシュボード仕様の貼り付け中または変換中にエラーが発生しました',
	'specCopyErr': 'ダッシュボード仕様のコピー中にエラーが発生しました',
	'pasteNotSupportedErr': '%{name} からの貼り付けはサポートされていません。',
	'reportParam': 'レポート',
	'filterWidgetCopyWarn': 'この時点ではフィルターがサポートされていないため、フィルターの視覚化はコピーされませんでした。',
	'upgradingDashboard': '%{version} の \'%{name}\' をアップグレードしています...',
	'upgradeComplete': 'アップグレード完了',
	'individualTabProperties': '個々のタブのプロパティー',
	'propMasterTabStylesLabel': 'マスター・タブのスタイル',
	'propTabPosition': 'タブの位置',
	'propTabTitle': 'タイトル',
	'propTabBackgroundColor': '塗りつぶし色',
	'propTabTextColor': 'タイトルの色',
	'propTabSelectedBarColor': '選択したバーの色',
	'propTabRestoreDefaults': 'デフォルトに戻す',
	'propIndividualTabStylesLabel': '個々のタブのスタイル',
	'propIndividualTabStylesAriaLabel': '個々のタブのスタイルのプロパティーを開く',
	'propTabIconPosition': 'アイコンの位置',
	'propLeftTitle': 'タイトルの左',
	'propRightTitle': 'タイトルの右',
	'propTopTitle': 'タイトルの上',
	'propBottomTitle': 'タイトルの下',
	'propTabIconLabel': '表示',
	'propTabIcon': 'アイコン',
	'propTabIconColor': 'アイコンの色',
	'no_icon': '空',
	'announcement': '発表',
	'api': 'API',
	'archive': 'アーカイブ',
	'asset': 'アセット',
	'attachment': '添付ファイル',
	'audio': '音声',
	'bee': 'Bee',
	'blog': 'ブログ',
	'bookmark': 'ブックマーク',
	'calendar': 'カレンダー',
	'camera': 'カメラ',
	'capability': '機能',
	'catalog': 'カタログ',
	'chat_message': 'チャット・メッセージ',
	'checkout_cart': 'チェックアウト・カート',
	'client': 'クライアント',
	'clock': '時計',
	'cloud': 'クラウド',
	'code': 'コード',
	'data_quality': 'データ品質',
	'folder': 'フォルダー',
	'forum': 'フォーラム',
	'glasses': '眼鏡',
	'group': 'グループ',
	'hat': '帽子',
	'headphone': 'ヘッドホン',
	'hills': '丘',
	'home': 'ホーム',
	'idea': 'アイデア',
	'image': '画像',
	'inventory': 'インベントリー',
	'like': 'いいね',
	'link': 'リンク',
	'location': 'ロケーション',
	'manage': '管理',
	'pen': 'ペン',
	'mobile_phone': '携帯電話',
	'music': '音楽',
	'notifications': '通知',
	'paint': 'ペイント',
	'payment': '支払い',
	'password_key': 'パスワード・キー',
	'people': '人',
	'person': '個人',
	'phone': '電話',
	'pin': 'ピン',
	'print': '印刷',
	'recording': '記録',
	'repository': 'リポジトリー',
	'role': '役割',
	'search': '検索',
	'properties': 'プロパティー',
	'speaker': 'スピーカー',
	'star': '星形',
	'tag': 'タグ',
	'thumbs_up': '賛成',
	'thumbs_down': '反対',
	'tools': 'ツール',
	'traffic': 'トラフィック',
	'trash': 'ごみ箱',
	'twitter': 'Twitter',
	'unknown': '不明',
	'user': 'ユーザー',
	'venn_diagram': 'ベン図表',
	'video': 'ビデオ',
	'view': 'ビュー',
	'warning': '警告',
	'watch': '監視',
	'watson': 'Watson',
	'wikis': 'Wiki',
	'workspace': 'ワークスペース',
	'world': '世界',
	'OnLoadFilterModifierDatasourceMismatch': 'ダッシュボードが別のソースを使用中のため、フィルターはターゲットに適用されません。',
	'OnLoadFilterModifierColumnMismatch': '一致する列が見つからないため、1 つまたは複数のフィルターが適用されませんでした。',
	'eventGroupButtonLabel': 'ウィジェット接続の表示',
	'dockToolbar': 'ツールバーの固定',
	'undockToolbar': 'ツールバーの切り離し',
	'propShowTitle': 'タイトルを表示'
});
